/* 
  Cookie Data implemented in the Cookie Policy table
*/
export type CookieURL = {
  service: string;
  cookieName: string;
  URL: string;
  company: string;
  validity: string;
  technology: string;
  dataCollect: any;
  dataRecipient: string;
  dataProtectionOfficer: any;
  dataProcessors: string;
  rightTerms: {
    title: string;
    content: string;
  };
  country: string;
  active: boolean;
  description: string;
}

/**
  * Cookies in Deutsch
  * Adyen            (1st Party)
  * Adyen            (1st Party)
  * Wallee           (1st Party)
  * Wallee           (1st Party)
  * Google           (1st Party)
  * Google           (1st Party)
  * Google           (1st Party)
  * -------------------------------
  * Meta (Facebook)  (3rd Party)
 */

//Adyen
const JSESSIONID_de: CookieURL =
{
  service: "Hypersoft Pay - powered by Adyen",
  cookieName: "JSESSIONID",
  URL: "checkoutshopper-live.adyen.com",
  company: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registriert bei der Niederländischen Handelskammer (Dutch Chamber of Commerce, Nr.: 34259528)",
  validity: "Die personenbezogenen Daten werden für die Dauer der Service-Nutzung (Sitzung) verarbeitet. Die personenbezogenen Daten werden gelöscht, sobald sie für die angegebenen Verarbeitungszwecke nicht mehr benötigt werden. ",
  technology: "Browser",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Referrer URL",
    content2: "-  User Agent",
    content3: "-  Benutzereinstellungen",
    content4: "-  ID",
    content5: "-  Uhrzeit",
  },
  dataRecipient: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registriert bei der Niederländischen Handelskammer (Dutch Chamber of Commerce, Nr.: 34259528)",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "dpo@adyen.com",
  },
  dataProcessors: "https://www.adyen.com/policies-and-disclaimer/cookie-policy",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Art. 6 Abs. 1 S. 1 lit. f DSGVO",
  }, country: "Europäische Union (Niederlande)",
  active: true,
  description: "JSESSIONID ist ein funktionales Cookie, der eine Browseranfrage mit einem bestimmten Adyen-Server verknüpft und sicherstellt, dass weitere Anfragen an denselben Server gehen. Es erstellt eine eindeutige Kennung für die Browsersitzung. Adyen benötigt dieses Cookie, damit seine Infrastruktur ordnungsgemäß funktioniert und daher ist diese Sitzungs-ID unbedingt erforderlich, um den Dienst anzubieten. Die Lebensdauer dieses Cookies ist an die Dauer der Browsersitzung gekoppelt.",
}

//Adyen
const _rp_uid_de: CookieURL =
{
  service: "Hypersoft Pay - powered by Adyen",
  cookieName: "_rp_uid",
  URL: "checkoutshopper-live.adyen.com",
  company: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registriert bei der Niederländischen Handelskammer (Dutch Chamber of Commerce, Nr.: 34259528)",
  validity: "Die personenbezogenen Daten werden für die Dauer der Service-Nutzung (Sitzung) verarbeitet. Die personenbezogenen Daten werden gelöscht, sobald sie für die angegebenen Verarbeitungszwecke nicht mehr benötigt werden. ",
  technology: "Browser",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Referrer URL",
    content2: "-  User Agent",
    content3: "-  Benutzereinstellungen",
    content4: "-  ID",
    content5: "-  Uhrzeit",
  },
  dataRecipient: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registriert bei der Niederländischen Handelskammer (Dutch Chamber of Commerce, Nr.: 34259528)",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "dpo@adyen.com",
  },
  dataProcessors: "https://www.adyen.com/policies-and-disclaimer/cookie-policy",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Art. 6 Abs. 1 S. 1 lit. f DSGVO",
  }, country: "Europäische Union (Niederlande)",
  active: true,
  description: "_rp_uid ist ein funktionales Cookie, der eine Browseranfrage mit einem bestimmten Adyen-Server verknüpft und eine Verlinkung des Einkäufers zum Risikosystem herstellt. Adyen benötigt dieses Cookie, damit seine Infrastruktur ordnungsgemäß funktioniert und daher ist diese Sitzungs-ID unbedingt erforderlich, um den Dienst anzubieten. Die Lebensdauer dieses Cookies ist an die Dauer der Browsersitzung gekoppelt.",
}

//Wallee
const _csrf_token_443_de: CookieURL =
{
  service: "Wallee",
  cookieName: "_csrf_token_443",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "As long as required",
  technology: "Javascript",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Zugriffsinformationen des Nutzers",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "Schweiz",
  active: true,
  description: "Es handelt sich hier um technische notwendige Informationen die für die Identifikation oder technische Sicherung der Applikation wallee notwendig sind.",
}

//Wallee
const _dbcctx_de: CookieURL =
{
  service: "Wallee",
  cookieName: "dbcctx",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "So lange wie nötig",
  technology: "Javascript",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Zugriffsinformationen des Nutzers",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "Schweiz",
  active: true,
  description: "Es handelt sich hier um technische notwendige Informationen die für die Identifikation oder technische Sicherung der Applikation wallee notwendig sind.",
}

//Wallee
const _language_de: CookieURL =
{
  service: "Wallee",
  cookieName: "language",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "So lange wie nötig",
  technology: "Javascript",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Zugriffsinformationen des Nutzers",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "Schweiz",
  active: true,
  description: "Es handelt sich hier um technische notwendige Informationen die für die Identifikation oder technische Sicherung der Applikation wallee notwendig sind.",
}

//Wallee
const _time_zone_name_de: CookieURL =
{
  service: "Wallee",
  cookieName: "time_zone_name",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "So lange wie nötig",
  technology: "Javascript",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Zugriffsinformationen des Nutzers",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "Schweiz",
  active: true,
  description: "Es handelt sich hier um technische notwendige Informationen die für die Identifikation oder technische Sicherung der Applikation wallee notwendig sind.",
}

//Wallee
const _time_zone_offset_de: CookieURL =
{
  service: "Wallee",
  cookieName: "time_zone_offset",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "So lange wie nötig",
  technology: "Javascript",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Zugriffsinformationen des Nutzers",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "Schweiz",
  active: true,
  description: "Es handelt sich hier um technische notwendige Informationen die für die Identifikation oder technische Sicherung der Applikation wallee notwendig sind.",
}

//Wallee
const _ga_de: CookieURL =
{
  service: "Google Analytics",
  cookieName: "_ga",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Google",
  validity: "So lange wie nötig",
  technology: "Javascript",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Zugriffsinformationen des Nutzers",
  },
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  },
  dataProcessors: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "United States",
  active: true,
  description: 'Google Analytics, ein Web-Analysedienst von Google Inc. (nachfolgend "Google"), verwendet Cookies, die auf dem Computer des Nutzers gespeichert werden. Die durch den Cookie erzeugten Informationen über den Besuch des Nutzers werden in der Regel an einen Server von Google in den USA übermittelt und dort gespeichert. Aktiviert Wallee AG für diese Website eine IP-Anonymisierung, kürzt Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum die IP-Adresse des Nutzers. Nur in Ausnahmefällen wird dann die volle IP-Adresse an einen Server von Google in den USA übermittelt und dort anonymisiert. Im Auftrag von Wallee AG wertet Google die gespeicherten Informationen aus, um Reports über die Nutzung der Website zusammenzustellen und um weitere damit verbundene Dienstleistungen für Wallee AG zu erbringen. Die im Rahmen von Google Analytics vom Browser des Nutzers übermittelte IP-Adresse führt Google unter Umständen mit anderen erhobenen Daten zusammen.',
}

//Wallee
const _gid_de: CookieURL =
{
  service: "Google Analytics",
  cookieName: "_gid",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Google",
  validity: "So lange wie nötig",
  technology: "Javascript",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Zugriffsinformationen des Nutzers",
  },
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  },
  dataProcessors: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "United States",
  active: true,
  description: 'Google Analytics, ein Web-Analysedienst von Google Inc. (nachfolgend "Google"), verwendet Cookies, die auf dem Computer des Nutzers gespeichert werden. Die durch den Cookie erzeugten Informationen über den Besuch des Nutzers werden in der Regel an einen Server von Google in den USA übermittelt und dort gespeichert. Aktiviert Wallee AG für diese Website eine IP-Anonymisierung, kürzt Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum die IP-Adresse des Nutzers. Nur in Ausnahmefällen wird dann die volle IP-Adresse an einen Server von Google in den USA übermittelt und dort anonymisiert. Im Auftrag von Wallee AG wertet Google die gespeicherten Informationen aus, um Reports über die Nutzung der Website zusammenzustellen und um weitere damit verbundene Dienstleistungen für Wallee AG zu erbringen. Die im Rahmen von Google Analytics vom Browser des Nutzers übermittelte IP-Adresse führt Google unter Umständen mit anderen erhobenen Daten zusammen.',
}

// Google Pay
const OTZ_de: CookieURL =
{
  service: "GooglePay",
  cookieName: "OTZ",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Google",
  validity: "So lange wie nötig",
  technology: "Javascript",
  dataCollect: {
    title: "Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden.",
    content1: "-  Informationen über das Nutzerverhalten",
    content2: "-  Informationen über die Navigation"
  },
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  },
  dataProcessors: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "United States",
  active: true,
  description: 'Dieses Cookie wird gesetzt, um Informationen über das Nutzerverhalten und die Navigation zu sammeln, die zur Optimierung der Website verwendet werden. Das Cookie ermöglicht es auch Google Ads und Google Analytics, Informationen über Besucher für Marketingzwecke zusammenzustellen.',
}

// Google Pay
const NID_de: CookieURL =
{
  service: "Google",
  cookieName: "NID",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Google",
  validity: "So lange wie nötig",
  technology: "Javascript",
  dataCollect: {},
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  },
  dataProcessors: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "United States",
  active: true,
  description: 'Registriert eine eindeutige ID, die das Gerät eines wiederkehrenden Nutzers identifiziert. Die ID wird für gezielte Werbung verwendet.',
}

// Google Pay
const CONSENT_de: CookieURL =
{
  service: "Google",
  cookieName: "CONSENT",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Google",
  validity: "Zwei Jahre",
  technology: "Javascript",
  dataCollect: {},
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  },
  dataProcessors: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "United States",
  active: true,
  description: 'Google verwendet das „CONSENT“-Cookie, das 2 Jahre bestehen bleibt, um die Cookie-Entscheidungen des Nutzers zu speichern.',
}

/**
 * 3rd Party
 */

const _fbp_de: CookieURL =
{
  service: "Meta Pixel",
  cookieName: "_fbp",
  URL: "connect.facebook.net",
  company: "Meta Platforms Ireland Limited",
  validity: "3 Monate",
  technology: "Browser",
  dataCollect: {
    title: "Meta (Facebook) stellt keine Informationen zur Verfügung ob, welche und warum Daten gesammelt werden.",
    content1: "-  Referrer URL",
    content2: "-  User Agent",
    content3: "-  Benutzereinstellungen",
    content4: "-  ID",
    content5: "-  Uhrzeit",
  },
  dataRecipient: "Meta Platforms Ireland Ltd. 4 Grand Canal Square Grand Canal Harbour Dublin 2, Irland Registriert in Irland (Companies Registration Office) Handelsregisternummer 462932",
  dataProtectionOfficer: {
    title: "Den Datenschutzbeauftragten von Meta (Facebook) können Sie über diesen Link kontaktieren:",
    email: "https://www.facebook.com/help/contact/540977946302970",
  },
  dataProcessors: "https://www.facebook.com/policies/cookies/",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Art. 6 Para. 1 DSGVO, Art. 49 Abs. 1 lit. a DSGVO",
  }, country: "Europäische Union (Irland)",
  active: false,
  description: "Die Verarbeitung der Informationen soll es zum einen Facebook ermöglichen, sein System der Werbung, die es über sein Netzwerk verbreitet, zu verbessern. Zum anderen soll sie uns als Betreiber der Seite ermöglichen, Statistiken zu erhalten, die Facebook aufgrund der Besuche unsere Seite erstellt. Die erstellten Besucherstatistiken werden ausschließlich in anonymisierter Form an uns übermittelt. Wir haben keinen Zugang zu den zugrundliegenden Daten. Diesen Zugang hat ausschließlich Meta (Facebook) selbst.",
}

const _cc_de: CookieURL =
{
  service: "Chef Campaigns",
  cookieName: "mca_*",
  URL: "skynet.mcanism.com",
  company: "MCANISM Technology GmbH ",
  validity: "",
  technology: "Browser",
  dataCollect: {},
  dataRecipient: "MCANISM Technology GmbH",
  dataProtectionOfficer: {
    title: "",
    email: "",
  },
  dataProcessors: "",
  rightTerms: {
    title: "",
    content: "",
  }, country: "",
  active: true,
  description: "",
}

/**
  * Cookies in english
  * Adyen            (1st Party)
  * Adyen            (1st Party)
  * Wallee           (1st Party)
  * Wallee           (1st Party)
  * Google           (1st Party)
  * Google           (1st Party)
  * Google           (1st Party)
  * -------------------------------
  * Meta (Facebook)  (3rd Party)
*/

//Adyen
const JSESSIONID_en: CookieURL =
{
  service: "Hypersoft Pay - powered by Adyen",
  cookieName: "JSESSIONID",
  URL: "checkoutshopper-live.adyen.com",
  company: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registered with the Dutch Chamber of Commerce, No.: 34259528.",
  validity: "Personal data is processed for the duration of the service use (session). The personal data will be deleted as soon as it is no longer needed for the specified processing purposes.",
  technology: "Browser",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  Referrer URL",
    content2: "-  User Agent",
    content3: "-  User settings",
    content4: "-  ID",
    content5: "-	Time of day",
  },
  dataRecipient: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registered with the Dutch Chamber of Commerce, No.: 34259528.",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "dpo@adyen.com",
  },
  dataProcessors: "https://www.adyen.com/policies-and-disclaimer/cookie-policy",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Art. 6 para. 1 p. 1 lit. f GDPR",
  },
  country: "European Union (Netherlands)",
  active: true,
  description: "JSESSIONID is a functional cookie that links a browser request to a specific Adyen server and ensures that further requests go to the same server. It creates a unique identifier for the browser session. Adyen needs this cookie for its infrastructure to function properly and therefore this session ID is strictly necessary to provide the service. The lifetime of this cookie is linked to the duration of the browsing session.",
}

//Adyen
const _rp_uid_en: CookieURL =
{
  service: "Hypersoft Pay - powered by Adyen",
  cookieName: "_rp_uid",
  URL: "checkoutshopper-live.adyen.com",
  company: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registered with the Dutch Chamber of Commerce, No.: 34259528.",
  validity: "Personal data is processed for the duration of the service use (session). The personal data will be deleted as soon as it is no longer needed for the specified processing purposes.",
  technology: "Browser",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  Referrer URL",
    content2: "-  User Agent",
    content3: "-  User settings",
    content4: "-  ID",
    content5: "-  Time",
  },
  dataRecipient: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registered with the Dutch Chamber of Commerce, No.: 34259528.",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "dpo@adyen.com",
  },
  dataProcessors: "https://www.adyen.com/policies-and-disclaimer/cookie-policy",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Art. 6 para. 1 p. 1 lit. f GDPR",
  },
  country: "European Union (Netherlands)",
  active: true,
  description: "rp_uid is a functional cookie that links a browser request to a specific Adyen server and establishes a link of the shopper to the risk system. Adyen needs this cookie for its infrastructure to function properly and therefore this session ID is strictly necessary to provide the service. The lifetime of this cookie is linked to the duration of the browser session.",
}

//Wallee
const _csrf_token_443_en: CookieURL =
{
  service: "Wallee",
  cookieName: "csrf_token_443",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "As long as required",
  technology: "Browser",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  User access information",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary to provide the service",
  },
  country: "Switzerland",
  active: true,
  description: "This is technical information necessary for the identification or technical security of the application wallee.",
}

//Wallee
const _dbcctx_en: CookieURL =
{
  service: "Wallee",
  cookieName: "dbcctx",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "As long as required",
  technology: "Browser",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  User access information",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary to provide the service",
  },
  country: "Switzerland",
  active: true,
  description: "This is technical information necessary for the identification or technical security of the application wallee.",
}

//Wallee
const _language_en: CookieURL =
{
  service: "Wallee",
  cookieName: "language",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "As long as required",
  technology: "Browser",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  User access information",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary to provide the service",
  },
  country: "Switzerland",
  active: true,
  description: "This is technical information necessary for the identification or technical security of the application wallee.",
}

//Wallee
const _time_zone_name_en: CookieURL =
{
  service: "Wallee",
  cookieName: "time_zone_name",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "As long as required",
  technology: "Browser",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  User access information",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary to provide the service",
  },
  country: "Switzerland",
  active: true,
  description: "This is technical information necessary for the identification or technical security of the application wallee.",
}

//Wallee
const _time_zone_offset_en: CookieURL =
{
  service: "Wallee",
  cookieName: "time_zone_offset",
  URL: "https://wallee.com/legal/datenschutzhinweise",
  company: "Cloudflare / wallee",
  validity: "As long as required",
  technology: "Browser",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  User access information",
  },
  dataRecipient: "Wallee Group AG",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "info@wallee.com",
  },
  dataProcessors: "https://wallee.com/legal/datenschutzhinweise",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary to provide the service",
  },
  country: "Switzerland",
  active: true,
  description: "This is technical information necessary for the identification or technical security of the application wallee.",
}

//Wallee
const _ga_en: CookieURL =
{
  service: "Google Analytics",
  cookieName: "_ga",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registered with the Dutch Chamber of Commerce, No.: 34259528.",
  validity: "As long as required",
  technology: "Javascript",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  User access information",
  },
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "You can find more information at http://tools.google.com/dlpage/gaoptout?hl=de or at http://www.google.com/intl/en/analytics/privacyoverview.html (general information about Google Analytics and data protection).",
  },
  dataProcessors: "You can find more information at http://tools.google.com/dlpage/gaoptout?hl=de or at http://www.google.com/intl/en/analytics/privacyoverview.html (general information about Google Analytics and data protection).",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary to provide the service",
  },
  country: "United States",
  active: true,
  description: "Google Analytics, a web analytics service provided by Google Inc. (hereinafter 'Google'), uses cookies that are stored on the user's computer. The information generated by the cookie about the user's visit is usually transmitted to a Google server in the USA and stored there. If Wallee AG activates IP anonymization for this website, Google will truncate the user's IP address within member states of the European Union or other states party to the Agreement on the European Economic Area. Only in exceptional cases will the full IP address then be transmitted to a Google server in the USA and anonymized there. On behalf of Wallee AG, Google evaluates the stored information in order to compile reports on the use of the website and to provide other related services for Wallee AG. Google may combine the IP address transmitted by the user's browser as part of Google Analytics with other data collected.",
}

//Wallee
const _gid_en: CookieURL =
{
  service: "Google Analytics",
  cookieName: "_gid",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Adyen N.V., Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands. Registered with the Dutch Chamber of Commerce, No.: 34259528.",
  validity: "As long as required",
  technology: "Javascript",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "-  User access information",
  },
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Below you will find the e-mail address of the data protection officer of the processing company. Adyen N.V., DPO, Simon Carmiggeltstraat 5-60, 1011 DJ Amsterdam, the Netherlands.",
    email: "You can find more information at http://tools.google.com/dlpage/gaoptout?hl=de or at http://www.google.com/intl/en/analytics/privacyoverview.html (general information about Google Analytics and data protection).",
  },
  dataProcessors: "You can find more information at http://tools.google.com/dlpage/gaoptout?hl=de or at http://www.google.com/intl/en/analytics/privacyoverview.html (general information about Google Analytics and data protection).",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary to provide the service",
  },
  country: "United States",
  active: true,
  description: "Google Analytics, a web analytics service provided by Google Inc. (hereinafter 'Google'), uses cookies that are stored on the user's computer. The information generated by the cookie about the user's visit is usually transmitted to a Google server in the USA and stored there. If Wallee AG activates IP anonymization for this website, Google will truncate the user's IP address within member states of the European Union or other states party to the Agreement on the European Economic Area. Only in exceptional cases will the full IP address then be transmitted to a Google server in the USA and anonymized there. On behalf of Wallee AG, Google evaluates the stored information in order to compile reports on the use of the website and to provide other related services for Wallee AG. Google may combine the IP address transmitted by the user's browser as part of Google Analytics with other data collected.",
}

// Google Pay
const OTZ_en: CookieURL =
{
  service: "GooglePay",
  cookieName: "OTZ",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Google",
  validity: "As long as necessary",
  technology: "Javascript",
  dataCollect: {
    title: "This list contains all (personal) data collected by or through the use of this service.",
    content1: "- Information about user behavior",
    content2: "- Information about the navigation"
  },
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Below you will find the email address of the data protection officer of the processing company.",
    email: "You can find more information at http://tools.google.com/dlpage/gaoptout?hl=en or at http://www.google.com/intl/en/analytics/privacyoverview.html (general information on Google Analytics and data protection)."
  },
  dataProcessors: "You can find more information at http://tools.google.com/dlpage/gaoptout?hl=en or at http://www.google.com/intl/en/analytics/privacyoverview.html (general information on Google Analytics and data protection).",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary for the provision of the service",
  }, country: "United States",
  active: true,
  description: 'This cookie is set to collect information about user behavior and navigation, which is used to optimize the website. The cookie enables'
}

// Google Pay
const NID_en: CookieURL =
{
  service: "Google",
  cookieName: "NID",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Google",
  validity: "As long as necessary",
  technology: "Javascript",
  dataCollect: {},
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Below you will find the email address of the data protection officer of the processing company.",
    email: "You can find more information at http://tools.google.com/dlpage/gaoptout?hl=en or at http://www.google.com/intl/en/analytics/privacyoverview.html (general information on Google Analytics and data protection)."
  },
  dataProcessors: "You can find more information at http://tools.google.com/dlpage/gaoptout?hl=en or at http://www.google.com/intl/en/analytics/privacyoverview.html (general information on Google Analytics and data protection).",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Legally necessary for the provision of the service",
  }, country: "United States",
  active: true,
  description: `Registers a unique ID that identifies a returning user's device.The ID is used for targeted advertising.`
}

// Google Pay
const CONSENT_en: CookieURL =
{
  service: "Google",
  cookieName: "CONSENT",
  URL: "https://policies.google.com/technologies/cookies",
  company: "Google",
  validity: "Two years",
  technology: "Javascript",
  dataCollect: {},
  dataRecipient: "Google",
  dataProtectionOfficer: {
    title: "Nachfolgend finden Sie die E-Mail-Adresse des Datenschutzbeauftragten des verarbeitenden Unternehmens.",
    email: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  },
  dataProcessors: "Mehr Informationen finden Sie unter http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter http://www.google.com/intl/en/analytics/privacyoverview.html (allgemeine Informationen zu Google Analytics und Datenschutz).",
  rightTerms: {
    title: "Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung von Daten genannt",
    content: "Rechtlich notwendig zur Erbrinung des Services",
  }, country: "United States",
  active: true,
  description: `Google uses the "CONSENT" cookie, which persists for 2 years, to store the user's cookie choices.`,
}

/**
 * 3rd Party
 */
const _fbp_en: CookieURL =
{
  service: "Meta Pixel",
  cookieName: "_fbp",
  URL: "connect.facebook.net",
  company: "Meta Platforms Ireland Limited",
  validity: "3 months",
  technology: "Browser",
  dataCollect: {
    title: "Meta (Facebook) does not provide any information on whether, which and why data is collected.",
  },
  dataRecipient: "Meta Platforms Ireland Ltd. 4 Grand Canal Square Grand Canal Harbour Dublin 2,  Registered in Ireland (Companies Registration Office) company registration number 462932",
  dataProtectionOfficer: {
    title: "You can contact Meta's (Facebook) data protection officer via this link:",
    email: "https://www.facebook.com/help/contact/540977946302970",
  },
  dataProcessors: "https://www.facebook.com/policies/cookies/",
  rightTerms: {
    title: "The following is the required legal basis for the processing of data",
    content: "Art. 6 Para. 1 DSGVO, Art. 49 Abs. 1 lit. a DSGVO",
  }, country: "European Union (Ireland)",
  active: false,
  description: "The processing of the information is intended, on the one hand, to enable Facebook to improve its system of advertising that it distributes via its network. On the other hand, it is intended to enable us, as the operator of the site, to obtain statistics that Facebook compiles on the basis of visits to our site. The visitor statistics generated are transmitted to us exclusively in anonymised form. We have no access to the underlying data. Only Meta (Facebook) itself has this access. Translated with www.DeepL.com/Translator (free version)",
}

const _cc_en: CookieURL =
{
  service: "Chef Campaigns",
  cookieName: "mca_*",
  URL: "skynet.mcanism.com",
  company: "MCANISM Technology GmbH ",
  validity: "",
  technology: "Browser",
  dataCollect: {},
  dataRecipient: "MCANISM Technology GmbH",
  dataProtectionOfficer: {
    title: "",
    email: "",
  },
  dataProcessors: "",
  rightTerms: {
    title: "",
    content: "",
  }, country: "",
  active: true,
  description: "",
}

export type CookieData = {
  ADYEN: CookieURL[],
  WALLEE: CookieURL[],
  GOOGLE_PAY: CookieURL[],
  META_PIXEL: CookieURL[],
  CHEF_CAMPAIGNS: CookieURL[]
}

const ADYEN_COOKIE_DATA_de: Array<CookieURL> = [JSESSIONID_de, _rp_uid_de]
const ADYEN_COOKIE_DATA_en: Array<CookieURL> = [JSESSIONID_en, _rp_uid_en]

const WALLEE_COOKIE_DATA_de: Array<CookieURL> = [_dbcctx_de, _csrf_token_443_de, _language_de, _time_zone_name_de, _time_zone_offset_de, _gid_de, _ga_de]
const WALLEE_COOKIE_DATA_en: Array<CookieURL> = [_dbcctx_en, _csrf_token_443_en, _language_en, _time_zone_name_en, _time_zone_offset_en, _gid_en, _ga_en]

const GOOGLE_PAY_COOKIE_DATA_de: Array<CookieURL> = [NID_de, OTZ_de, CONSENT_de]
const GOOGLE_PAY_COOKIE_DATA_en: Array<CookieURL> = [NID_en, OTZ_en, CONSENT_en]

const META_PIXEL_COOKIE_DATA_de: Array<CookieURL> = [_fbp_de]
const META_PIXEL_COOKIE_DATA_en: Array<CookieURL> = [_fbp_en]

const CHEF_CAMPAIGNS_COOKIE_DATA_de: Array<CookieURL> = [_cc_de]
const CHEF_CAMPAIGNS_DATA_en: Array<CookieURL> = [_cc_en]

export const COOKIE_DATA: { de: CookieData, en: CookieData } = {
  de: {
    ADYEN: ADYEN_COOKIE_DATA_de,
    WALLEE: WALLEE_COOKIE_DATA_de,
    GOOGLE_PAY: GOOGLE_PAY_COOKIE_DATA_de,
    CHEF_CAMPAIGNS: CHEF_CAMPAIGNS_COOKIE_DATA_de,
    META_PIXEL: META_PIXEL_COOKIE_DATA_de

  },
  en: {
    ADYEN: ADYEN_COOKIE_DATA_en,
    WALLEE: WALLEE_COOKIE_DATA_en,
    GOOGLE_PAY: GOOGLE_PAY_COOKIE_DATA_en,
    CHEF_CAMPAIGNS: CHEF_CAMPAIGNS_DATA_en,
    META_PIXEL: META_PIXEL_COOKIE_DATA_en

  }
}

